import { Fragment } from 'react';
import { agents } from '../../data/catalysts';
import { items } from '../../data/items';
import { ItemLink } from '../item';

const Recipe = ({ element, recipe, ingredients, setIngredients, product, onAddAgentToBasket }) => {
	const couldUseAgent = product.minScore > 0;
	return (
		<div>
			<h3>Recipe</h3>
			{couldUseAgent && (
				<>
					<h4 style={{ marginBottom: 0 }}>Agent</h4>
					<fieldset className="agent-list">
						{agents[element].map((agent, ai) => (
							<div key={ai}>
								<p>
									<label htmlFor={`agent-${ai}`}>
										<input
											id={`agent-${ai}`}
											type="checkbox"
											checked={ingredients[4]?.id === agent.id}
											onChange={(e) => {
												const newIngredients = [...ingredients];
												newIngredients[4] = e.target.checked ? { ...agent, productId: product.id, element, isAgent: true } : null;
												setIngredients(newIngredients);
											}}
										/>
										<img
											src={`./assets/items/${agent.id}.gif`}
											alt={agent.name}
											title={agent.name}
										/>
										{agent.name}
										{agent.isCraftable && (
											<button
												className="add-to-basket"
												onClick={() => onAddAgentToBasket(agent.id)}
											>
												<img
													src={'./assets/icon--plus.svg'}
													alt={'Add to basket'}
													title={'Add to basket'}
													className={'icon'}
												/>
											</button>
										)}
									</label>
								</p>
								<div className="recipe__elements">
									{['air', 'earth', 'fire', 'water', 'quality'].map((e) => (
										<span key={e} className={`ele-box ${e}`}>
											{agent[e]}
										</span>
									))}
								</div>
							</div>
						))}
					</fieldset>
				</>
			)}
			<div className="recipe grid grid-sm-4">
				{recipe.map((r, ri) => (
					<div key={ri}>
						<p><strong>TYPE: {r}</strong></p>
						{items[element][r]?.map((item, ii) => {
							if (ingredients[ri]?.isSpecificMain) {
								if (ii === 0) {
									return (
										<div
											key={ingredients[ri].id}
											className={'disabled'}
										>
											<p>
												<label htmlFor={`item-${ri}-${ii}`}>
													<input
														id={`item-${ri}-${ii}`}
														type="checkbox"
														checked={true}
														disabled={true}
														onChange={undefined}
													/>
													<ItemLink item={ingredients[ri]} />
												</label>
											</p>
											<div className="recipe__elements">
												{['air', 'earth', 'fire', 'water', 'quality'].map((e) => (
													<span key={e} className={`ele-box ${e}`}>
														{ingredients[ri][e]}
													</span>
												))}
											</div>
											<p>
												<small>Using this item as a first material is mandatory. Use an agent to boost the element value to reach the min-score.</small>
											</p>
										</div>
									);
								}
								return <Fragment key={item.id}></Fragment>;
							}
							// Checkbox is disabled, if any item of the current column is already selected
							// or if the item has already been selected in another column.
							const isChecked = ingredients[ri]?.id === item.id;
							const isDisabled = !isChecked && (ingredients[ri]);

							return (
								<div
									key={item.id}
									className={isDisabled ? 'disabled' : undefined}
								>
									<p>
										<label htmlFor={`item-${ri}-${ii}`}>
											<input
												id={`item-${ri}-${ii}`}
												type="checkbox"
												checked={isChecked}
												disabled={isDisabled}
												onChange={(e) => {
													const newIngredients = [...ingredients];
													newIngredients[ri] = e.target.checked ? { ...item, productId: product.id, element, type: r } : null;
													setIngredients(newIngredients);
												}}
											/>
											<ItemLink item={item} />
										</label>
									</p>
									<div className="recipe__elements">
										{['air', 'earth', 'fire', 'water', 'quality'].map((e) => (
											<span key={e} className={`ele-box ${e}`}>
												{item[e]}
											</span>
										))}
									</div>
								</div>
							);
						})}
					</div>
				))}
			</div>
		</div>
	);
};

export default Recipe;
